import script from "./VersionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionPage.vue?vue&type=script&setup=true&lang=js"

import "./VersionPage.vue?vue&type=style&index=0&id=811bee1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-811bee1e"]])

export default __exports__